import React from "react";
import { AthleteDTO } from "../../interfaces/AthletesDTO";
import { formatTime } from "../../services/timeHandler";
import { eventBus } from "../../services/eventHandler";

interface Props {
  athletes: AthleteDTO[] | undefined;
  classname: string;
}

const TeamBox = ({ athletes, classname }: Props) => {
  const handleClick = (athleteid: AthleteDTO | null) => {
if (athleteid === null){
  return;
}
    eventBus.emit(`selctedathlete`, athleteid);
    let styleElement = document.getElementById("web-selected-style");
    if (styleElement) {
      styleElement.textContent = `[data-athleteid="${athleteid.ID}"] { background: rgb(128 128 128 / 40%)  !important; }`;
    }
  };
  const getFormatedStatus = (inp:string) : string => {
    if (inp.length > 0){
      if (inp[0] == "D"){
        return inp;
      }
    }
    return "";
  }
  if (athletes === undefined) {
    return <></>;
  }

  return (
    <div className="team-table-box">
      <div className="team-table-header-text">{classname}</div>
      <div>
        <table className="team-table">
          <tbody>
            {athletes.map((obj, ind) => {
              return (
                <tr
                  className="team-table-row"
                  key={ind}
                  data-athleteid={obj.ID}
                  style={{
                    order:
                      999 in obj.Times
                        ? obj.Times[999].RankClass
                        : obj.Startno + 1000,
                  }}
                  onClick={() => handleClick(obj)}
                >
                  <td className="team-table-rank">
                    {999 in obj.Times && (obj.Status === "OK" || obj.Status === "START" || obj.Status === "ENT")
                      ? obj.Times[999].RankClass
                      : ""}
                  </td>
                  <td className="team-table-startno">{obj.Startno}</td>
                  <td className="team-table-name">{obj.FormatedShortName}</td>
                  <td className="team-table-runtime">
                    {999 in obj.Times && (obj.Status === "OK" || obj.Status === "START" || obj.Status === "ENT")
                      ? formatTime(obj.Times[999].RunTime, "T")
                      : getFormatedStatus(obj.Status)}
                  </td>
                  <td className="team-table-difftime">
                    {999 in obj.Times && (obj.Status === "OK" || obj.Status === "START" || obj.Status === "ENT")
                      ? "+" + formatTime(obj.Times[999].DiffClass, "T")
                      : ""}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamBox;
